import { useStaticQuery, graphql } from 'gatsby';

// The full menu_primary tree is fetched directly from the Storyblok CDN at build
// time (see `sourceNodes` in gatsby-node.js) and stored as a JSON string. Parsing
// it here keeps the render free to walk arbitrarily nested nav blocks without the
// GraphQL schema having to declare every level.
export default function useStoryblokGlobalNav() {
    const data = useStaticQuery(graphql`
        query globalNavRaw {
            storyblokGlobalNavRaw {
                menuPrimaryJson
            }
        }
    `);

    let menuPrimary = [];
    const json = data?.storyblokGlobalNavRaw?.menuPrimaryJson;
    if (json) {
        try {
            menuPrimary = JSON.parse(json);
        } catch (err) {
            console.error('[global-nav] Failed to parse menu_primary JSON:', err.message);
        }
    }

    return { menu_primary: Array.isArray(menuPrimary) ? menuPrimary : [] };
}
